export class CheckInModel {
  siteId: number;
  branchName: string;
  location: string
  buyerName: string;
  latitude: number;
  longitude: number;
  selfCheckIn: boolean;
}